import React from 'react';
import { propEq, find } from 'ramda';
import PropTypes from 'prop-types';
import { isBlank } from 'utils/helperMethods';
import { Typography, Link, Button } from '@material-ui/core';
import MessagePresenter from 'presenters/MessagePresenter';
import Icon from 'sharedComponents/Icon';
import { useTranslation } from 'react-i18next';

import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';
import BidPresenter from 'presenters/BidPresenter';

import useStyles from './useStyles';

const BidMessage = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { message, isCurrentUserMessage, chatUid } = props;

  const { chats } = useFirebaseChat();

  const bid = MessagePresenter.data(message);
  const chat = find(propEq('uid', chatUid), chats);
  const latestBid = FirebaseChatPresenter.latestBid(chat);
  const isLatestBid = !isBlank(latestBid) && bid.id === latestBid.id;
  const isApplicationUrlPresent = !isBlank(BidPresenter.loanOfficerApplicationUrl(bid));
  const shouldShowApplyButton = isApplicationUrlPresent && !isCurrentUserMessage && isLatestBid;

  return (
    <div className={classes.root}>
      <div className={classes.topBox}>
        <div width="60%">
          <Typography variant="subtitle1" color="secondary" noWrap>
            {t('models.App.bid.interestRate')}
          </Typography>
          <Typography color="inherit" variant="h2" className={classes.text}>
            {BidPresenter.getInterestRate(bid)}
          </Typography>
        </div>
        <div width="36%">
          <Typography variant="subtitle1" color="secondary" noWrap>
            {t('models.App.bid.apr')}
          </Typography>
          <Typography variant="h2" color="inherit" className={classes.text}>
            {BidPresenter.getApr(bid)}
          </Typography>
        </div>
      </div>
      <div className={classes.bottomBox}>
        <Typography variant="subtitle1" color="secondary" noWrap>
          {t('models.App.bid.payment')}
        </Typography>
        <Typography variant="h2" color="inherit" className={classes.text}>
          {BidPresenter.monthlyPrInMi(bid)}
        </Typography>
      </div>
      {shouldShowApplyButton && (
        <div className={classes.controlBox}>
          <Button
            target="_blank"
            href={BidPresenter.loanOfficerApplicationUrl(bid)}
            component={Link}
            className={classes.applyButton}
            startIcon={<Icon name="done" className={classes.icon} />}
          >
            {t('components.Chat.Messages.Message.BidMessage.applyButton')}
          </Button>
        </div>
      )}
    </div>
  );
};

BidMessage.propTypes = {
  message: MessagePresenter.shape().isRequired,
  chatUid: PropTypes.string.isRequired,
  isCurrentUserMessage: PropTypes.bool.isRequired,
};

export default BidMessage;



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/components/BidMessage/BidMessage.js